import { render, staticRenderFns } from "./DashboardPadrinho.vue?vue&type=template&id=de456238&scoped=true&"
import script from "./DashboardPadrinho.vue?vue&type=script&lang=js&"
export * from "./DashboardPadrinho.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPadrinho.vue?vue&type=style&index=0&id=de456238&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de456238",
  null
  
)

export default component.exports